var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coursePullComponent",on:{"click":_vm.goToCourse}},[_c('img',{attrs:{"src":_vm.courseImage,"alt":""}}),(_vm.type === 'help')?_c('p',[_vm._v(_vm._s(_vm.isBuy || _vm.helpStatus === 1 ? '（课程已领取 ，立即去听课）' : '（领取课程后，点击可查看课程详情）'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }